module.exports = __webpack_public_path__ + "static/media/QPOS.75462607.png";